import useSWR from "swr";

import { type DocumentReleaseDetails } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/document-releases";

export function useDocumentRelease(id: string | number | undefined) {
  return useSWR<DocumentReleaseDetails, Error>(
    id ? `${url}/${id}` : null,
    simpleFetcher,
  );
}
